import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import icon from '../../assets/svg/arogyabee-labs-icon.png';
import { accountDeletion } from '../../service/api.service';

import './LabAccountDeletionInfo.css';

const LabAccountDeletionInfo = () => {
  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'ArogyaBee Labs – Account Deletion Request';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  const initialValues = {
    email: '',
    reason: '',
  };

  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }
    return errors;
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const body = {
      email: values.email,
      reason: values.reason,
      accountType: 'lab',
    };
    accountDeletion(body)
      .then((res) => {
        console.log('res: ', res);
      })
      .catch((err) => {
        console.log(err);
      });
    setSuccessMessage(true);
    setSubmitting(false);
  };

  return (
    <div className="form-container">
      {successMessage ? (
        <div className="success-container">
          <h2 className="success-title">Request Submitted Successfully!</h2>
          <p className="success-text">
            Your account deletion request has been received. A member of the
            eDigitizeYourself (eHomosapiens) team will contact you shortly.
          </p>
        </div>
      ) : (
        <>
          <div className="header-section">
            <img src={icon} alt="ArogyaBee Labs" className="company-logo" />
            <h1 className="company-name">ArogyaBee Labs</h1>
            <p className="owner-name">eDigitizeYourself (eHomosapiens)</p>
          </div>

          <h2 className="form-title">Account Deletion Request</h2>
          <p className="owner-name">
            A member of the eDigitizeYourself (eHomosapiens) team will reach
            out to you to assist with your request.
          </p>

          <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email address
                  </label>
                  <Field
                    type="email"
                    id="email"
                    name="email"
                    placeholder="you@lab.com"
                    className="form-input"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="form-error"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="reason" className="form-label">
                    Reason for deletion (optional)
                  </label>
                  <Field
                    as="textarea"
                    id="reason"
                    name="reason"
                    placeholder="Tell us why you'd like to delete your account…"
                    className="form-input form-textarea"
                  />
                  <ErrorMessage
                    name="reason"
                    component="div"
                    className="form-error"
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="form-button"
                >
                  Submit Request
                </button>
              </Form>
            )}
          </Formik>
        </>
      )}
    </div>
  );
};

export default LabAccountDeletionInfo;
